// src/ProfileForm.js
import React, { useState } from "react";
import {
  TextField,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Container,
  Typography,
  Box,
  Link,
} from "@mui/material";

const ProfileForm = () => {
  const [formValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    email: "",
    mobile: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
  };

  return (
    <Container>
      <Box
        sx={{ backgroundColor: "white", p: 4, boxShadow: 3, borderRadius: 2 }}
      >
        <Typography variant="h2" gutterBottom>
          Personal Information
        </Typography>
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: "flex" }}>
            <TextField
              margin="normal"
              label="First Name"
              name="firstName"
              value={formValues.firstName}
              onChange={handleChange}
              sx={{ width: "300px" }}
            />
            <TextField
              margin="normal"
              label="Last Name"
              name="lastName"
              value={formValues.lastName}
              onChange={handleChange}
              sx={{ width: "300px", marginLeft: 1 }}
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{
                width: "100px",
                height: "50px",
                marginTop: 2,
                borderRadius: "10px",
                marginLeft: 1,
              }}
            >
              Save
            </Button>
          </Box>
          <RadioGroup
            name="gender"
            value={formValues.gender}
            onChange={handleChange}
            row
            sx={{ marginTop: 2 }}
          >
            <Box>
              <Typography variant="h4">Your Gender</Typography>
              <FormControlLabel value="male" control={<Radio />} label="Male" />
              <FormControlLabel
                value="female"
                control={<Radio />}
                label="Female"
              />
            </Box>
          </RadioGroup>
          <Box sx={{ marginTop: 2 }}>
            <Typography variant="h4">Email Address</Typography>
            <TextField
              margin="normal"
              label="Email Address"
              name="email"
              value={formValues.email}
              onChange={handleChange}
              sx={{ width: "300px" }}
            />
          </Box>
          <Box sx={{ marginTop: 2 }}>
            <Typography variant="h4">Mobile Number</Typography>
            <TextField
              margin="normal"
              label="Mobile Number"
              name="mobile"
              value={formValues.mobile}
              onChange={handleChange}
              sx={{ width: "300px" }}
            />
          </Box>
        </form>
        <Typography variant="h4" gutterBottom mt={4}>
          FAQs
        </Typography>
        <Typography variant="body1" gutterBottom sx={{ marginTop: 2 }}>
          <strong>
            What happens when I update my email address (or mobile number)?
          </strong>
          <br />
          Your login email id (or mobile number) changes, likewise. You&apos;ll
          receive all your account related communication on your updated email
          address (or mobile number).
        </Typography>
        <Typography variant="body1" gutterBottom sx={{ marginTop: 2 }}>
          <strong>
            When will my Flipkart account be updated with the new email address
            (or mobile number)?
          </strong>
          <br />
          It happens as soon as you confirm the verification code sent to your
          email (or mobile) and save the changes.
        </Typography>
        <Typography variant="body1" gutterBottom sx={{ marginTop: 2 }}>
          <strong>
            What happens to my existing Flipkart account when I update my email
            address (or mobile number)?
          </strong>
          <br />
          Updating your email address (or mobile number) doesn&apos;t invalidate
          your account. Your account remains fully functional. You&apos;ll
          continue seeing your Order history, saved information and personal
          details.
        </Typography>
        <Typography variant="body1" gutterBottom sx={{ marginTop: 2 }}>
          <strong>
            Does my Seller account get affected when I update my email address?
          </strong>
          <br />
          Flipkart has a &apos;single sign-on&apos; policy. Any changes will
          reflect in your Seller account also.
        </Typography>
        <Box mt={5}>
          <Link href="#" color="primary">
            Deactivate Account
          </Link>
        </Box>
        <Box mt={2}>
          <Link href="#" color="secondary">
            Delete Account
          </Link>
        </Box>
      </Box>
    </Container>
  );
};

export default ProfileForm;
